import React from 'react';

const DataTableContext = React.createContext({});

export default DataTableContext;
